import * as React from "react";

function SvgMonetate(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 66.4 78.4"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M64 52.8c-3 7.6-6.6 7.2-6.6 7.2-7.3 0-7.6-10.7-7.6-12.2 0-1.6.3-12.2 7.6-12.2 0 0 3.6-.4 6.6 7.1 0 0 1.1.9 2.4.4v-14c0-5.3-4.5-9.5-10-9.5H42c-5.5-1.6-2.9-4.8-2.9-4.8 8.7-3.2 8.2-6.9 8.2-6.9C47.3.3 35 0 33.2 0c-1.8 0-14.1.3-14.1 7.9 0 0-.5 3.7 8.2 6.9 0 0 2.6 3.2-2.9 4.8H10c-5.5 0-10 4.3-10 9.5v13.7c1.4 1 2.9-.1 2.9-.1 3.1-7.6 6.6-7.1 6.6-7.1 7.3 0 7.6 10.7 7.6 12.2S16.8 60 9.5 60c0 0-3.6.4-6.6-7.1 0 0-1.5-1.1-2.9-.1v16.1c0 5.3 4.5 9.5 10 9.5h18.4c.7-1.2-.3-2.4-.3-2.4-7.5-2.7-7.1-5.2-7.1-5.2 0-6.5 10.5-6.8 12.1-6.8 1.5 0 12.1.3 12.1 6.8 0 0 .4 2.5-7.1 5.2 0 0-1 1.2-.3 2.4h18.4c5.5 0 10-4.3 10-9.5V52.4c-1-.4-2.2.4-2.2.4z"
        fill="#2a90cf"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMonetate);
